import { render, staticRenderFns } from "./background_child.vue?vue&type=template&id=6244b1ac&scoped=true"
import script from "./background_child.vue?vue&type=script&lang=js"
export * from "./background_child.vue?vue&type=script&lang=js"
import style0 from "./background_child.vue?vue&type=style&index=0&id=6244b1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244b1ac",
  null
  
)

export default component.exports